export const APP_NAME = "Ethara.AI";
export const APP_TAGLINE = "AI-Native Financial Intelligence";

// Original logo (black on transparent/white) — used on LIGHT backgrounds (e.g. PDF export)
export const LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_business-metrics-48/artifacts/h14h5dak_WhatsApp%20Image%202026-06-29%20at%206.56.33%20PM.jpeg";

// White emblem (lotus badge only) on transparent — for dark UI, small spots
export const LOGO_MARK =
  "https://static.prod-images.emergentagent.com/jobs/a23efc85-a92f-40f4-af13-bbd408f290fd/images/c12d16cf9f2f72a4e8e1a7f25d4c7a615d765b50ed4dd904204bf4a4eb46d415.png";

// White full logo (emblem + Ethara.AI wordmark) on transparent — for dark UI hero
export const LOGO_FULL =
  "https://static.prod-images.emergentagent.com/jobs/a23efc85-a92f-40f4-af13-bbd408f290fd/images/0efd5549efbe2073a5ff161e61d8d5ede0c8c87bc660005f42a892f820c983d1.png";

// Backward-compat alias (PDF + legacy refs use the light/black logo)
export const LOGO_URL = LOGO_DARK;

export const CHART = {
  revenue: "#22D3AA",
  expenses: "#FF3B5C",
  net: "#00F0FF",
  grid: "var(--chart-grid)",
  axis: "var(--chart-axis)",
};

export const PIE_COLORS = ["#00F0FF", "#B026FF", "#FF3B9A", "#FFB020", "#3B82F6", "#22D3EE", "#A855F7"];
